import { useCallback, useState } from 'react'
import {useLocalStorage} from "../use_local_storage";

export const useTrixLocalStorage = (editorRef, persistToLS) => {
  const [editorMetaData, setEditorMetaData] = useState({})
  const ls = useLocalStorage()

  const getEditorsFromStorage = useCallback(() => {
    return ls.getItem('editors') || {}
  }, [ls])

  const getEditorFromStorage = useCallback(
    (id) => {
      const editors = getEditorsFromStorage()
      return editors[id]
    },
    [getEditorsFromStorage],
  )

  const setStorage = useCallback((json) => {
    ls.setItem('editors', json)
  }, [ls])

  const saveEditorToStorage = useCallback(
    (id, value = null) => {
      if (!persistToLS) {
        return
      }
      const localStorage = getEditorsFromStorage()

      const document = value ? value.document : editorRef.current.getDocument()
      let metaData = {
        [id]: {
          attachments: {},
        },
      }
      document.getAttachments().forEach((attachment) => {
        metaData[id]['attachments'][attachment.attributes.values.prevId] = {
          previewURL: attachment.previewURL,
        }
        attachment.setAttributes({
          prevId: attachment.attributes.values.prevId,
        })
      })
      setEditorMetaData((state) => ({ ...state, ...metaData }))
      localStorage[id] = value || editorRef.current
      setStorage(localStorage)
    },
    [editorRef, getEditorsFromStorage, persistToLS, setStorage],
  )

  const deleteEditorInStorage = useCallback((id) => {
    const localStorage = getEditorsFromStorage()
    delete localStorage[id]
    setStorage(localStorage)
  }, [getEditorsFromStorage, setStorage])

  return {
    editorMetaData,
    getEditorFromStorage,
    saveEditorToStorage,
    deleteEditorInStorage,
  }
}
